import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from 'src/app/base/services/general/general.service';
import { PersistenciaService } from 'src/app/base/services/persistencia/persistencia.service';
import { UsuarioService } from 'src/app/base/services/usuario/usuario.service';
import { BaseComponent } from 'src/app/models/base-component';
import { CampeonatosService } from '../../services/campeonatos/campeonatos.service';

/* Unifica de una vez los jugadores registrados mas de una vez: mismo C.I., o sin C.I. con el mismo nombre.
   Se conserva el que tiene foto y esta en un campeonato activo; las reglas estan en tor-rutas-duplicados-jugadores.js */
@Component({
    selector: 'app-jugadores-duplicados',
    templateUrl: './jugadores-duplicados.component.html',
    styleUrls: ['./jugadores-duplicados.component.css'],
    standalone: false
})
export class JugadoresDuplicadosComponent extends BaseComponent implements OnInit {

  @Output() alTerminar:EventEmitter<any>  = new EventEmitter<any>();
  grupos:any[]=[];
  omitidos:any[]=[];
  texto_busqueda:string="";
  solo_revisar:boolean=false;
  cargando:boolean=true;
  resultado:any=null;

  constructor(
    public generalService:GeneralService,
    public persistenciaService:PersistenciaService,
    public usuarioService:UsuarioService,
    public modalService: NgbModal,
    private toastr: ToastrService,
    public campeonatosService:CampeonatosService) {
      super(persistenciaService,modalService,generalService,usuarioService);
  }

  async ngOnInit(): Promise<void> {
    await this.cargarVistaPrevia();
  }

  async cargarVistaPrevia(){
    this.cargando=true;
    let res:any=await this.campeonatosService.obtenerJugadoresDuplicados(this.usuario.id_empresa).toPromise();
    this.cargando=false;
    if(res.tiene_error){
      this.toastr.error(res.mensaje);
      return;
    }
    //todos marcados: el usuario solo desmarca los que no son la misma persona
    res.grupos.forEach(grupo => grupo.unificar=true);
    this.grupos=res.grupos;
    this.omitidos=res.omitidos;
  }

  //los armados por nombre parecido o con jugadores de otro club son los que conviene mirar antes de unificar
  esParaRevisar(grupo){
    return grupo.por_parecido || grupo.otro_club;
  }

  obtenerGruposMarcados(){
    return this.grupos.filter(grupo => grupo.unificar);
  }

  contarRegistrosSobrantes(){
    return this.obtenerGruposMarcados().reduce((total,grupo) => total+grupo.jugadores.length-1,0);
  }

  contarParaRevisar(){
    return this.grupos.filter(grupo => this.esParaRevisar(grupo)).length;
  }

  obtenerGruposFiltrados(){
    let texto=(this.texto_busqueda || "").trim().toUpperCase();
    return this.grupos.filter(grupo => (!this.solo_revisar || this.esParaRevisar(grupo)) &&
      (!texto || grupo.jugadores.some(jugador =>
        (jugador.nombre_completo || "").toUpperCase().indexOf(texto)>-1 || (jugador.ci || "").toString().indexOf(texto)>-1)));
  }

  async unificarTodo(){
    let marcados=this.obtenerGruposMarcados();
    if(marcados.length==0){
      this.toastr.error("¡No hay grupos marcados para unificar!");
      return;
    }
    if(!confirm("Se unificarán "+marcados.length+" jugadores y se quitarán "+this.contarRegistrosSobrantes()+" registros repetidos. Esta acción no se puede deshacer desde el sistema. ¿Continuar?")){
      return;
    }
    let excluir=this.grupos.filter(grupo => !grupo.unificar).map(grupo => grupo.clave);
    this.blockUI.start();
    let res:any=await this.campeonatosService.unificarTodosJugadoresDuplicados(this.usuario.id_empresa,excluir).toPromise();
    this.blockUI.stop();
    if(res.tiene_error){
      this.toastr.error(res.mensaje);
      return;
    }
    this.resultado=res;
    this.toastr.success(res.mensaje);
    res.errores.forEach(error => this.toastr.error(error));
    await this.cargarVistaPrevia();
  }

  cerrarComponente(){
    this.alTerminar.emit(this.resultado);
  }

}
